import type { RouteComponentProps } from '@reach/router';
import React from 'react';

import { useGetInsurance } from '@hooks/api/insurance';
import { useCuration } from '@hooks/useCuration';
import { useSession } from '@hooks/useSession';

import Content from './Content';

const InsuranceDrilldown: React.FC<RouteComponentProps & { id?: string }> = ({
  id = '',
}) => {
  const {
    state: { activeProfile, isCurator },
  } = useSession();
  const {
    state: { isCreating, isEditing },
    finishAddingRecord,
    startAddingRecord,
    stopCurating,
    stopEditingRecord,
  } = useCuration();
  const [patient_id] = [activeProfile?.patient_id];

  React.useEffect(() => {
    if (id === 'add') {
      startAddingRecord();
    }
    return () => stopCurating();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const { data, loading } = useGetInsurance({
    record_id: id,
  });

  const handleSubmit = () => {
    stopEditingRecord();
    finishAddingRecord();
  };

  return (
    <Content
      data={data}
      isCreating={isCreating}
      isCurator={isCurator}
      isEditing={isEditing}
      loading={loading}
      onSubmit={handleSubmit}
      patientId={patient_id}
    />
  );
};

export default InsuranceDrilldown;
